/* tslint:disable */
/* eslint-disable */
/**
 * Webclipping
 * WebclippingのAPI
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClipReportSummaryV2ChartBarChart
 */
export interface ClipReportSummaryV2ChartBarChart {
    /**
     * 
     * @type {string}
     * @memberof ClipReportSummaryV2ChartBarChart
     */
    date: string;
    /**
     * 
     * @type {number}
     * @memberof ClipReportSummaryV2ChartBarChart
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof ClipReportSummaryV2ChartBarChart
     */
    releaseOriginalReprint?: number;
    /**
     * 
     * @type {number}
     * @memberof ClipReportSummaryV2ChartBarChart
     */
    publicityReprint?: number;
    /**
     * 
     * @type {number}
     * @memberof ClipReportSummaryV2ChartBarChart
     */
    publicity?: number;
}

export function ClipReportSummaryV2ChartBarChartFromJSON(json: any): ClipReportSummaryV2ChartBarChart {
    return ClipReportSummaryV2ChartBarChartFromJSONTyped(json, false);
}

export function ClipReportSummaryV2ChartBarChartFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClipReportSummaryV2ChartBarChart {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'date': json['date'],
        'total': json['total'],
        'releaseOriginalReprint': !exists(json, 'release_original_reprint') ? undefined : json['release_original_reprint'],
        'publicityReprint': !exists(json, 'publicity_reprint') ? undefined : json['publicity_reprint'],
        'publicity': !exists(json, 'publicity') ? undefined : json['publicity'],
    };
}

export function ClipReportSummaryV2ChartBarChartToJSON(value?: ClipReportSummaryV2ChartBarChart | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'date': value.date,
        'total': value.total,
        'release_original_reprint': value.releaseOriginalReprint,
        'publicity_reprint': value.publicityReprint,
        'publicity': value.publicity,
    };
}

